  // Coming back from registration: send them back to the cart.
  // For whatever reason the Shopify theme is not doing this.
  (function () {
    var previousUrl = document.referrer;
    if (previousUrl == 'https://onedaytests.com/account/register?return_to=/cart') {
      if (window.location.href == 'https://onedaytests.com/') {
        window.location.replace('https://onedaytests.com/cart');
        return;
      } 
    } 
    
    if (window.location.href.includes('weight-loss-subscription')) {
      if (!window.location.href.includes('access=123')) {
        window.location.replace('https://onedaytests.com/products/book-your-free-weight-loss-assessment-and-blood-test');
      } 
    } 
  })();